import React from 'react';
import PageTemplate from '../../../components/template/PageTemplate';
import RemoteImageReferralListContainer from '../../../containers/remoteImage/referral/RemoteImageReferralListContainer';
import { REMOTE_REFERRAL_IMAGE_PAGE_NAME } from '../../../constants/service/app/remoteImageConstants';

const RemoteImageReferralList = () => {
  return (
    <PageTemplate pageName={REMOTE_REFERRAL_IMAGE_PAGE_NAME.REMOTE_REFERRAL_IMAGE_LIST}>
      <RemoteImageReferralListContainer />
    </PageTemplate>
  );
};

export default RemoteImageReferralList;
